'use client';

import { FC } from 'react';
import { useTranslations } from 'next-intl';
import { MailIcon, PhoneIcon } from '@/components';
import { COLORS, WLAS_SUPPORT_EMAIL, WLAS_SUPPORT_PHONE } from '@/constants';
import { toTelHref } from '@/utils/formatPhone';
import {
  ContactBox,
  ContactBoxBody,
  ContactBoxHeader,
  ContactIconBox,
  ContactLabel,
  ContactLink,
  ContactRow,
  ContactTextBlock,
  ContactTitle,
  DescriptionText,
} from './styled';

const ICON_COLOR = COLORS['primary/700'];

export const WlasContactBox: FC = () => {
  const t = useTranslations('wlasWidget.contact');

  return (
    <ContactBox>
      <ContactBoxHeader>
        <ContactTitle>{t('title')}</ContactTitle>
      </ContactBoxHeader>
      <ContactBoxBody>
        <DescriptionText>{t('description')}</DescriptionText>
        <ContactRow>
          <ContactIconBox>
            <PhoneIcon width={20} height={20} color={ICON_COLOR} />
          </ContactIconBox>
          <ContactTextBlock>
            <ContactLabel>{t('phoneLabel')}</ContactLabel>
            <ContactLink href={`tel:${toTelHref(WLAS_SUPPORT_PHONE)}`}>
              {WLAS_SUPPORT_PHONE}
            </ContactLink>
          </ContactTextBlock>
        </ContactRow>
        <ContactRow>
          <ContactIconBox>
            <MailIcon width={20} height={20} color={ICON_COLOR} />
          </ContactIconBox>
          <ContactTextBlock>
            <ContactLabel>{t('emailLabel')}</ContactLabel>
            <ContactLink href={`mailto:${WLAS_SUPPORT_EMAIL}`}>{WLAS_SUPPORT_EMAIL}</ContactLink>
          </ContactTextBlock>
        </ContactRow>
      </ContactBoxBody>
    </ContactBox>
  );
};
